<template>
	<div>
		<button class="btn btn-mila text-white font-size-sm-8 font-size-10 float-right box-purple" @click="copyme()">
			<i class="fas fa-share-alt mt-auto mb-auto img-fluid pr-1"></i>
			Bagikan Tautan Toko
		</button>
		<input type="hidden" :value="getUrlReferal()" id="inputCopy">
	</div>
</template>

<script>
import { mapState } from 'vuex'
export default {
	computed: {
		...mapState('auth', ['profile']),
	},
	methods: {
		getUrlReferal() {
			return `${process.env.VUE_APP_STORE_URL}/mobile-counter/${this.profile.stockist_code}`
		},
		copyme() {
			var copyText = document.getElementById("inputCopy")
			copyText.setAttribute('type', 'text')
			copyText.select()
			try {
				document.execCommand('copy');
				setTimeout(() => {
					this.$emit('success')
				}, 300);
			} catch (err) {
				alert('Oops, tidak dapat menyalin');
			}
			copyText.setAttribute('type', 'hidden')
			window.getSelection().removeAllRanges()
		},
	}
}
</script>